import { atom } from "recoil";

export const chequeSettingsState = atom({
    key: 'chequeSettingsState',
    default: []
})

export const chequeSettingsFilterState = atom({
    key: 'chequeSettingsFilterState',
    default: ''
})